import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static targets = ["date"];
  static values = {
    minDate: String,
    maxDate: String,
    disabled: { type: Boolean, default: false },
  };

  connect() {
    this.datepicker();
  }

  datepicker() {
    if (!this.hasDateTarget) return;

    const options = {
      locale: "ja",
      static: true,
      dateFormat: "Y/m/d",
      allowInput: true,
      // 範囲外の日付を手入力した場合に入力値がクリアされないようにする（範囲外はサーバー側のバリデーションで案内する）
      allowInvalidPreload: true,
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
      clickOpens: false,
      disableMobile: true,
      // カレンダーからの選択はネイティブのinput/changeイベントを発火しないため、明示的に発火する
      onChange: () => {
        this.dateTarget.dispatchEvent(new Event("change", { bubbles: true }));
      },
    };

    flatpickr(this.dateTarget, options);

    if (!this.dateTarget._flatpickr) {
      // 日付として解釈できない値（例:「あああ」）がプリロードされると、
      // flatpickr内部で初期化に失敗し（エラーはflatpickr内部でconsole.errorされるのみで例外は外に投げられない）、
      // _flatpickrが設定されずカレンダーが開けなくなるため、入力欄を一時的に空にして再初期化したうえで、元の入力値を戻す
      const originalValue = this.dateTarget.value;
      this.dateTarget.value = "";
      flatpickr(this.dateTarget, options);
      this.dateTarget.value = originalValue;
    }

    if (this.disabledValue) {
      this.dateTarget.disabled = true;
    }
  }

  openDatepicker(event) {
    event.preventDefault();
    this.dateTarget._flatpickr.open();
  }
}
